import { createSlice } from "@reduxjs/toolkit";
import { showSymbol } from "../actions";

const initialState = {
  symbol: [],
};

const symbolSlice = createSlice({
  name: "symbol",
  initialState,
  reducers: {},
  extraReducers: {
    [showSymbol.fulfilled]: (state, action) => {
      state.symbol = action.payload || [];
    },
  },
});

export const responseSymbol = (state) => state.symbol;

export default symbolSlice.reducer;
